import { defineStore } from 'pinia';

interface MenuState {
  isMenuOpen: boolean;
}
  
export default defineStore('menu', {
  state: (): MenuState => ({
    isMenuOpen: false,
  }),
  actions: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
});